function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconDocumentFormRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 2v7h7l-7-7z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 15h8v-2h-8v2zm0 5h8v-2h-8v2zm0 5h8v-2h-8v2zm-4-10h2v-2h-2v2zm0 5h2v-2h-2v2zm0 5h2v-2h-2v2zm17-14h-7a2 2 0 01-2-2V2H7a2 2 0 00-2 2v24a2 2 0 002 2h18a2 2 0 002-2V11z",
    fill: props.color
  }));
}

export default SvgIconDocumentFormRexFilled;